import { render, staticRenderFns } from "./StatsMain.vue?vue&type=template&id=369afaf9&"
import script from "./StatsMain.vue?vue&type=script&lang=js&"
export * from "./StatsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports